import { Globals } from "../CoreApp/Globals";
import { enumUISubModes } from "../constants";
import { isInViewManager } from "./isInViewManager";
import { isInBackgroundEditor } from "./isInBackgroundEditor";

export function isInStandardSubmode() {
  return (
    Globals._uiConfig.GetUISubMode() === enumUISubModes.standard &&
    !isInViewManager() &&
    !isInBackgroundEditor()
  );
}
